'use strict';

/**
 * Image utility functions
 * @module util/imageUtils
 */

/**
 * Handles broken images by hiding the image and showing a placeholder
 * @param {HTMLImageElement} img - The image element
 * @param {string} placeholderSelector - Selector for the placeholder element
 */
function handleImageError(img, placeholderSelector) {
    const container = img.parentElement;
    const placeholder = container?.querySelector(placeholderSelector);

    img.hidden = true;
    if (placeholder) placeholder.hidden = false;
}

/**
 * Sets up image fallback handling for one or more images
 * @param {NodeList|HTMLImageElement[]} images - Images to handle
 * @param {string} placeholderSelector - Selector for placeholder elements
 */
function setupImageFallback(images, placeholderSelector) {
    images.forEach((img) => {
        const onError = () => handleImageError(img, placeholderSelector);

        if (img.complete) {
            // Image already loaded/failed - check if broken
            if (img.naturalWidth === 0) onError();
        } else {
            // Image still loading - attach listener
            img.addEventListener('error', onError);
        }
    });
}

export { handleImageError, setupImageFallback };
